export default "__VITE_ASSET__C7FjClwA__"